var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.permissionDetail)?[_c('topsearch',{attrs:{"title":_vm.permissionDetail.name}}),_c('TransactionList',{attrs:{"table":_vm.table,"permissions":_vm.permissionDetail,"tablename":_vm.permissionDetail.name,"detailurl":"/detail/"}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }